<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="contrast w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/choice" class="cl_gray">3+2+1选科</router-link>  >  我收藏的组合</p>
				</div>
			</div>
			<div class="contrast_title flex">
				<h3 class="f18px bold">我收藏的组合</h3>
				<!-- <router-link to="/contrast" class="contrast_title_coll cl_white tc">开始对比</router-link> -->
			</div>
			<div class="choice_coll_cont">
				<div class="choice_coll_list radius8" v-for="(item,index) in collect" :key="index">
					<div class="choice_coll_list_top">
						<p class="cl_violet f30px mar15">{{index+1}}</p>
						<div class="mar15">
							<h3 class="f18px">{{item.name}}</h3>
							<p class="f12px cl_gray mat5">可报考{{item.num}}的本、专科专业</p>
						</div>
						<!-- <button type="button" class="cl_violet mal15 mar15">选为模拟选科</button> -->
						<img src="../../../static/close_violet.png" @click="collectCancel(item.id)" />
					</div>
					<div class="choice_coll_list_btm cl_gray tc">
						<!-- <p><span>加入对比</span></p>
						<p><span>专业覆盖率</span></p> -->
						<p><router-link  :to="{ name: '选科查询系统-按科目组合', params: { collect: item.collect}}" class="cl_gray">可报专业</router-link></p>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'choice_collect',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 1,
				collect: [],
			}
		},
		mounted() {
			this.getCollect();
		},
		created() {
			
		},
		methods: {
			//获取收藏
			getCollect () {
				var that = this;
				that.$get("/api/selectsubject/get_user_collect_select_subject",{token: localStorage.getItem("token")})
				.then(res => {
					that.collect = res.data;
					for (let i = 0; i < that.collect.length; i++) {
						that.collect[i].collect = JSON.stringify(that.collect[i])
					}
				});
			},
			//取消收藏
			collectCancel (e) {
				this.$get("/api/selectsubject/post_collect_select_subject",{
					token: localStorage.getItem("token"),
					id: e,
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					this.getCollect();
				});
			},
		},
	}
</script>

<style>
</style>
